module.exports = __webpack_public_path__ + "img/76006.8c8ed523.svg";